import React from "react"
import { useTheme } from "styled-components"

const CorporateLogo = ({ className }: { className?: string }) => {
  const theme = useTheme()
  return <img src={theme.logo} className={className} alt="Corporate logo" />
}

export default CorporateLogo
